import type { Task } from '@/src/renderer/lib/db/models'
import type { OptimisticUpdates } from '../../../hooks/useTaskDragAndDrop'

/**
 * Was **Kurz notiert** zeigt: die rohen Aufgaben mit den vorläufigen Werten darüber, ohne ruhende.
 *
 * - **Feld-Überschreibungen** (Haken, Datum …) aus `useOptimisticTaskOverrides`.
 * - **Reihenfolge** aus `useOptimisticOrder` — nur `order`. Die Abschnitte hier sind gedacht
 *   (nach Alter), ein `sectionId` ordnet nichts. Bis 28.09.2026 kam die Reihenfolge gar nicht
 *   an: Nach dem Loslassen stand die Zeile an ihrem Ursprung, bis die Datenbank antwortete, die
 *   Landebewegung flog dorthin, dann sprang die Zeile ans Ziel (Bildschirmaufnahme, 2 Bilder).
 *
 * Unveränderte Aufgaben behalten ihre Referenz, damit die Zeilen-Memos greifen.
 */
export function shownQuickNotes(
  tasks: Task[] | undefined,
  overrides: ReadonlyMap<string, Partial<Task>>,
  orderUpdates: OptimisticUpdates,
): Task[] | undefined {
  if (!tasks) return tasks
  if (overrides.size === 0 && !orderUpdates) return tasks.filter(t => t.pausedAt == null)
  return tasks.flatMap(t => {
    const override = overrides.get(t.id)
    const order = orderUpdates?.get(t.id)?.order
    const merged = override || order !== undefined
      ? { ...t, ...override, ...(order !== undefined ? { order } : {}) }
      : t
    if (merged.pausedAt != null) return []
    return [merged]
  })
}
